import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';

@HookClass('user')
export class UserHook extends BaseHook {

    @Hook('31e06812-95d8-4af7-ba13-06b6f5bd5de7')
    public getUserDetailByUserId(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('AuthSecurityService')
            .pipe(concatMap((service: any) => {
                return service.getUserDetailByUserId(inputArtifact.object.userId);
            }))
            .pipe(map((user: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = user;
                artifact.kind = ArtfactKind.ANY;
                return artifact;
            }));
    }

    @Hook('ba3c079c-90f3-4f66-b365-72c1539632cc')
    public getUserDetailByUserIdAndSystemId(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('AuthSecurityService')
            .pipe(concatMap((service: any) => {
                return service.getUserDetailByUserIdAndSystemId(inputArtifact.object.userId, inputArtifact.object.systemId);
            }))
            .pipe(map((user: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = user;
                artifact.kind = ArtfactKind.ANY;
                return artifact;
            }));
    }

    @Hook('b60bc085-21b5-4bf5-befa-e44b87c97edd')
    public getUserDetailByUsername(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('AuthSecurityService')
            .pipe(concatMap((service: any) => {
                return service.getUserDetailByUsername(inputArtifact.object.username, inputArtifact.object.systemId);
            }))
            .pipe(map((user: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = user;
                artifact.kind = ArtfactKind.ANY;
                return artifact;
            }));
    }

    @Hook('0738c96c-c9f8-4eb8-b707-fc8686dd9640')
    public updateUserInfo(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('AuthSecurityService')
            .pipe(concatMap((service: any) => {
                return service.updateUserInfo(inputArtifact.object.data);
            }))
            .pipe(map((user: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = user;
                artifact.kind = ArtfactKind.ANY;
                return artifact;
            }));
    }

    @Hook('f5f9159e-f5c7-48e1-ad4b-90256297428b')
    public disableUser(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('AuthSecurityService')
            .pipe(concatMap((service: any) => {
                return service.disableUser(inputArtifact.object.userId);
            }))
            .pipe(map((user: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = user;
                return artifact;
            }));
    }

    @Hook('a0b3a040-b383-4e48-a4c2-903c0057d818')
    public enableUser(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('AuthSecurityService')
            .pipe(concatMap((service: any) => {
                return service.enableUser(inputArtifact.object.userId);
            }))
            .pipe(map((user: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = user;
                return artifact;
            }));
    }

    @Hook('6aa089fd-6b63-4702-8c66-7721870f2b48')
    public deleteUser(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('AuthSecurityService')
            .pipe(concatMap((service: any) => {
                return service.deleteUser(inputArtifact.object.userId);
            }))
            .pipe(map((user: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = user;
                return artifact;
            }));
    }

    @Hook('ec120769-bab4-4e67-a63f-7ef84bdae0f9')
    public loadRuleGroup(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('AuthSecurityService')
            .pipe(concatMap((service: any) => {
                return service.loadRuleGroup(inputArtifact.object.systemId, inputArtifact.object.page, inputArtifact.object.pageSize);
            }))
            .pipe(map((user: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = user;
                return artifact;
            }));
    }

    @Hook('d7a12fcd-a599-4629-818f-c0a41fb3089c')
    public changeUserRuleGroupId(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('AuthSecurityService')
            .pipe(concatMap((service: any) => {
                return service.changeUserRuleGroupId(inputArtifact.object.userId, inputArtifact.object.ruleGroupId);
            }))
            .pipe(map((user: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = user;
                return artifact;
            }));
    }

    @Hook('c0495ea9-32d4-4f8b-b937-61a3e708ea8a')
    public changeUserPassword(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('AuthSecurityService')
            .pipe(concatMap((service: any) => {
                return service.changeUserPassword(inputArtifact.object.userId, inputArtifact.object.password);
            }))
            .pipe(map((user: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = user;
                return artifact;
            }));
    }

    @Hook('c192aaa9-6704-4696-9338-2a0fa58c255b')
    public createUpdateRuleGroup(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('AuthSecurityService')
            .pipe(concatMap((service: any) => {
                return service.createUpdateRuleGroup(inputArtifact.object.data);
            }))
            .pipe(map((user: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = user;
                return artifact;
            }));
    }

    @Hook('b3104785-b23c-45c1-b3ae-3f8d63e928d3')
    public changeUserPasswordWithSystemId(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.service('AuthSecurityService')
            .pipe(concatMap((service: any) => {
                return service.changeUserPasswordWithSystemId(inputArtifact.object.userId, inputArtifact.object.password, inputArtifact.object.systemId);
            }))
            .pipe(map((user: any) => {
                const artifact = new NickProcessArtfact();
                artifact.object = user;
                return artifact;
            }));
    }
}
